import React, { Component } from 'react';
import { graphql, compose } from 'react-apollo';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { withCookies } from 'react-cookie';
import WelcomeMatExtension from '../../site-render/src/WelcomeMatExtension';

const createLead = gql`
  mutation createLead($input: LeadInput!) {
    createLead(input: $input) {
      id
    }
  }
`;

const COOKIE_KEY_SUCCESS = 'welcome-mat-success';
const COOKIE_KEY_DISMISSED = 'welcome-mat-dismissed';
const ONE_DAY = 24 * 60 * 60;

class WelcomeMatExtensionContainer extends Component {
  static propTypes = {
    cookies: PropTypes.object.isRequired,
    eventId: PropTypes.string.isRequired,
    mutate: PropTypes.func.isRequired,
    language: PropTypes.string.isRequired,
  };

  state = {
    loading: false,
    success: false,
    open: false,
  };

  componentDidMount() {
    const { cookies } = this.props;
    this.setState({ open: !cookies.get(COOKIE_KEY_SUCCESS) && !cookies.get(COOKIE_KEY_DISMISSED) });
  }

  closeDialog = () => {
    this.setState({ open: false });
    this.props.cookies.set(COOKIE_KEY_DISMISSED, true, { path: '/', maxAge: 2 * ONE_DAY });
  };

  onSubmit = async values => {
    const {
      cookies,
      mutate,
      language,
      site: { eventId },
    } = this.props;
    try {
      this.setState({ loading: true });
      await mutate({
        variables: {
          input: {
            source: 'welcomeMatExtension',
            eventId,
            language,
            ...values,
          },
        },
      });
      this.setState({ loading: false, success: true });
      window.setTimeout(() => {
        this.setState({ open: false });
      }, 1000);
      cookies.set(COOKIE_KEY_SUCCESS, true, { path: '/' });
    } catch (e) {
      // TODO: handle error
      this.setState({ open: false, loading: false });
      console.error(e);
    }
  };

  render() {
    const { open, loading, success } = this.state;
    return (
      <WelcomeMatExtension
        {...this.props}
        open={open}
        loading={loading}
        success={success}
        onRequestClose={this.closeDialog}
        onSubmit={this.onSubmit}
      />
    );
  }
}

export default compose(
  withCookies,
  graphql(createLead),
)(WelcomeMatExtensionContainer);



// WEBPACK FOOTER //
// ./src/containers/WelcomeMatExtensionContainer/WelcomeMatExtensionContainer.js